import { environment } from '../../environments/environment';

type SentryUser = {
  id: string;
  role?: string;
};

let modulePromise: Promise<typeof import('@sentry/angular') | null> | null = null;

function hasSentryDsn(): boolean {
  return environment.sentryDsn.trim().length > 0;
}

function ensureLoaded(): Promise<typeof import('@sentry/angular') | null> {
  if (!hasSentryDsn()) {
    return Promise.resolve(null);
  }
  if (!modulePromise) {
    modulePromise = import('@sentry/angular').catch(() => null);
  }
  return modulePromise;
}

export function initializeSentry(): void {
  if (!environment.production || !hasSentryDsn()) {
    return;
  }

  void ensureLoaded().then((Sentry) => {
    if (!Sentry) {
      return;
    }
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: 'production',
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      release: environment.appVersion,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
    });
  });
}

export async function setSentryUser(user: SentryUser | null): Promise<void> {
  const Sentry = await ensureLoaded();
  Sentry?.setUser(user);
}
